import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PatexamsSidebarService {
  /** PatexamsSidebarComponent → PatexamsComponent: open patient-details popup */
  readonly showPat$ = new Subject<void>();
}
